import React from 'react';
import { Button, Grid, List, ListItem, ListItemAvatar, ListItemText, Paper, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { lightGreen } from '@material-ui/core/colors';
import { ArrowRightIcon } from '@material-ui/pickers/_shared/icons/ArrowRightIcon';
import { useHistory, useParams } from 'react-router-dom';

type CouponPackMasterAboutTabProps = {
  idCouponPackMaster?: string;
  nameCouponPackMaster?: string;
  available?: boolean;
  codeCouponPackMaster?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  infoArea: {
    borderColor: theme.palette.primary.light,
    backgroundColor: lightGreen['50'],
  },
}));

export const CouponPackMasterAboutTab: React.FC<CouponPackMasterAboutTabProps> = ({
  idCouponPackMaster,
  nameCouponPackMaster,
  available,
  codeCouponPackMaster,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { couponPackMasterId } = useParams<{ couponPackMasterId: string }>();

  const data = [
    { label: '利用可否', value: available ? '利用可能' : '利用不可' },
    { label: '回数券マスタID', value: idCouponPackMaster },
    { label: '回数券名', value: nameCouponPackMaster },
    { label: '回数券コード', value: codeCouponPackMaster },
  ];

  return (
    <Grid container>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper variant="outlined" square className={classes.infoArea}>
            <List dense>
              {data.map((row, index) => (
                <ListItem key={index}>
                  <ListItemAvatar>
                    <ArrowRightIcon />
                  </ListItemAvatar>
                  <ListItemText primary={row.label} secondary={row.value} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Button
            fullWidth
            type="button"
            size="large"
            color="secondary"
            variant="contained"
            onClick={() => {
              history.push({
                pathname: `/coupon-pack-masters/${couponPackMasterId}/edit`,
                search: history.location.search,
              });
            }}
          >
            この回数券マスタを編集
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
